const templates = {};
const callbacks = {};
const columnTypeFactories = [];

const noValue = "";
const filters = {
  contains(fieldName, value, childFieldName) {
    const field = childFieldName ? `${fieldName}/${childFieldName}` : fieldName;
    return `contains(tolower(${field}), '${String(value).toLowerCase().replace(/'/g, "''")}')`;
  },
  anyContains(fieldName, value, childFieldName) {
    const item = "x";
    return `${fieldName}/any(${item}: ${filters.contains(`${item}/${childFieldName}`, value)})`;
  }
};

class ColumnType {
  constructor(options = {}, api = null) {
    this.options = options;
    this.api = api;
    this.sourceProp = options.data || options.name || "";
    this.multiSelect = !!options.multiSelect;
  }

  displayValue(value) {
    return value == null ? noValue : String(value);
  }

  createFilter() {
    return '<input type="text" class="form-control input-sm table-filter">';
  }

  createEditor(value) {
    const input = document.createElement("input");
    input.className = "table-input";
    input.value = value == null ? "" : String(value);
    return input;
  }

  getEditorValue(cellElement) {
    const input = cellElement.querySelector(".table-input");
    return input ? input.value : null;
  }

  buildPatchData(value) {
    return value;
  }

  buildFilterExpression(fieldName, columnFilter) {
    return filters.contains(fieldName, columnFilter);
  }

  getSelectedOption(item) {
    if (!item) {
      return "";
    }
    const id = item.id ?? item.value ?? item;
    const text = item.name ?? item.text ?? item.value ?? item;
    return `<option selected="selected" value="${id}">${text}</option>`;
  }
}

class StringColumn extends ColumnType {}
class LookupColumn extends StringColumn {}
class DateColumn extends ColumnType {}

function addTemplates(items) {
  Object.assign(templates, items);
  window.linksoft = window.linksoft || {};
  window.linksoft.datatableTemplates = templates;
}

function addCallbacks(items) {
  Object.assign(callbacks, items);
  window.linksoft = window.linksoft || {};
  window.linksoft.datatableCallbacks = callbacks;
}

function addColumnType(predicate, columnType) {
  columnTypeFactories.push({ predicate, columnType });
  window.linksoft = window.linksoft || {};
  window.linksoft.datatableColumnTypes = columnTypeFactories;
}

const datatables = {
  addCallbacks,
  addColumnType,
  addTemplates,
  callbacks,
  columnTypeFactories,
  columnTypes: {
    ColumnType,
    DateColumn,
    LookupColumn,
    StringColumn
  },
  filters,
  noValue,
  templates
};

window.linksoft = window.linksoft || {};
window.linksoft.datatables = datatables;

export { callbacks, columnTypeFactories, filters, noValue, templates };
export default datatables;
